import SkuPreviewPopover, {
  SkuPreviewPopoverProps,
} from "components/Shared/SkuPreviewPopover";
import { selectedProductLine, selectedSku } from "utils/links";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import Link, { LinkProps } from "components/Shared/Link";
import { Box, BoxProps } from "@chakra-ui/react";

type ProductLineNameProps = BoxProps;

export function ProductLineName({ children, ...rest }: ProductLineNameProps) {
  return (
    <Box
      opacity={0.75}
      fontSize=".8em"
      fontWeight="lighter"
      display="block"
      lineHeight="normal"
      mb=".25em"
      {...rest}
    >
      {children}
    </Box>
  );
}

function ProductLineNameLink(props: ProductLineNameProps & LinkProps) {
  return <ProductLineName as={Link} {...props} />;
}

export const skuNameCellFragment = gql(/* GraphQL */ `
  fragment SkuNameCell on Sku {
    id
    name
    productLine {
      id
      name
    }
  }
`);

type Props = {
  isAdmin?: boolean;
  sku: FragmentType<typeof skuNameCellFragment> | null | undefined;
  popoverProps?: Omit<SkuPreviewPopoverProps, "children" | "skuId">;
};

export default function SkuNameCell({
  isAdmin,
  sku: skuFragmentData,
  popoverProps,
}: Props) {
  const sku = getFragmentData(skuNameCellFragment, skuFragmentData);
  return (
    <>
      {isAdmin ? (
        <ProductLineName>{sku?.productLine?.name}</ProductLineName>
      ) : (
        <ProductLineNameLink href={selectedProductLine(sku?.productLine?.id)}>
          {sku?.productLine?.name}
        </ProductLineNameLink>
      )}

      <SkuPreviewPopover isAdmin={isAdmin} skuId={sku?.id} {...popoverProps}>
        {isAdmin ? (
          <Box as="span" display="block" lineHeight="normal">
            {sku?.name}
          </Box>
        ) : (
          <Link href={selectedSku(sku?.id)} display="block" lineHeight="normal">
            {sku?.name}
          </Link>
        )}
      </SkuPreviewPopover>
    </>
  );
}
